import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import PandagoCancelBooking from '@/plugins/graphql/mutations/v2/cancel-pandago-booking.gql';
import EcommerceOrder from '@/plugins/graphql/queries/v2/order.gql';
import CreditsWidget from '@/plugins/graphql/queries/v2/grab-express-credits.gql';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import { ORDER } from '@/helpers/constants/Store';
import { Mutation } from 'vuex-class';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
const namespace = { namespace: ORDER };
let CancelPandagoBooking = class CancelPandagoBooking extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.toggle = false;
        this.mutationRequestOnFlight = false;
    }
    async uponConfirm() {
        this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
        await this.cancelBooking()
            .then(() => {
            if (this.xsOnly) {
                this.hideOrderDetails();
            }
            this.successNotification(`Successfully cancel PandaGo Booking`);
            this.$router.push({
                name: 'ecommerce-orders-by-status',
                params: { status: 'completed' },
            });
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.mutationRequestOnFlight = !this.mutationRequestOnFlight;
            this.toggleConfirmation();
        });
    }
    async cancelBooking() {
        const appUuid = this.appUUID;
        const { orderUuid } = this;
        return this.$apollo.mutate({
            mutation: PandagoCancelBooking,
            variables: {
                input: {
                    orderUuid,
                },
            },
            refetchQueries: [
                {
                    query: EcommerceOrder,
                    variables: {
                        orderUuid,
                    },
                },
                {
                    query: CreditsWidget,
                    variables: {
                        appUuid,
                    },
                },
            ],
        });
    }
    toggleConfirmation() {
        this.toggle = !this.toggle;
    }
};
__decorate([
    Prop({ type: String, required: true })
], CancelPandagoBooking.prototype, "orderUuid", void 0);
__decorate([
    Mutation('hideOrderDetails', namespace)
], CancelPandagoBooking.prototype, "hideOrderDetails", void 0);
CancelPandagoBooking = __decorate([
    Component({
        components: {
            ActionButton,
            FormHeader,
        },
    })
], CancelPandagoBooking);
export default CancelPandagoBooking;
